import React, { Component } from 'react';

class AlertBannerBlock extends Component {

    constructor(props) {
        super(props);
    }

    render() { 
        return (
            <div className='alert-banner'>
                {this.props.messages.map((message, index) => (
                    <div
                        key={this.props.key}
                        className={`alert alert-${this.props.alertType || 'danger'}`}
                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                    >
                        {message}
                    </div>
                ))}
            </div>
        );
    }
}
 
export default AlertBannerBlock;